import axios from "axios";
import { fabric } from "fabric";
import { APIURL } from "../../config";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { ProductMargin } from "../Templates/ProductMargin";

export function CanvasArea(props) {
  const {
    currentPage,
    setCurrentPage,
    setCanvasObjects,
    canvasObjects,
    setcanvases,
    setcanvasesOriganl,
    canvasesOriganl,
    setcanvasObj,
    setLoader,
    closeTab,
    templateID,
    setShowToolbar,
    setTextToolbar,
    setelementStrokColor,
    setshowUploadToolbar,
    updateID,
    createID,
    currentPageObject,
    setSelectedIndex,
    settemplateID,
    onPageCanvasReady,
  } = props;

  const { loadCategories } = useParams();

  const canvasesRef = useRef([]);
  const initializedRef = useRef(false);

  const [categoryObj, setCategoryObj] = useState(null);
  const [Productmargin, setProductmargin] = useState(false);
  const [safeMargin, setsafeMargin] = useState(false);
  const [cutMargin, setcutMargin] = useState(false);

  const safeDecodeURIComponent = (v) => {
    try {
      return decodeURIComponent(v);
    } catch {
      return v;
    }
  };

  const VALID_TEXT_BASELINES = new Set([
    "top",
    "hanging",
    "middle",
    "alphabetic",
    "ideographic",
    "bottom",
  ]);

  const normalizeTextBaseline = (obj) => {
    if (!obj) return;
    if (obj.type !== "textbox" && obj.type !== "i-text") return;

    let baseline = obj.textBaseline;
    if (baseline === "alphabetical") baseline = "alphabetic";
    if (!VALID_TEXT_BASELINES.has(baseline)) baseline = "alphabetic";
    obj.textBaseline = baseline;
  };

  /* ======================================================
     1️⃣ LOAD DATA (templateID / createID / updateID / category)
  ====================================================== */
  useEffect(() => {
    const loadData = async () => {
      setLoader(true);
      initializedRef.current = false;

      // cleanup old canvases
      canvasesRef.current.forEach((c) => c?.dispose());
      canvasesRef.current = [];
      // setcanvases([]);
      // setcanvasObj(null);
      // setCanvasObjects([]);

      try {
        let finalTemplateId = updateID || createID || templateID;
        let categoryData = null;

        // CATEGORY MODE
        if (!finalTemplateId) {
          const catApi = loadCategories
            ? `${APIURL}/api/v1/categories/${loadCategories}`
            : `${APIURL}/api/v1/categories`;

          const catRes = await axios.get(catApi);
          const firstCat = catRes.data.data?.[0];
          if (!firstCat) return;

          const catDetail = await axios.post(`${APIURL}/api/v1/category`, {
            cat_slug: firstCat.cat_slug,
          });

          categoryData = catDetail.data.data[0];
          finalTemplateId = categoryData.template_id;
          settemplateID(finalTemplateId);
        }

        // TEMPLATE LOAD
        const tplRes = await axios.get(`${APIURL}/api/v1/template`, {
          params: { template_id: finalTemplateId },
        });

        const pages = tplRes.data.page_data;

        // CATEGORY FROM TEMPLATE
        if (!categoryData) {
          const catSlug = tplRes.data.data[0]?.cat_slug;
          const catDetail = await axios.post(`${APIURL}/api/v1/category`, {
            cat_slug: catSlug,
          });
          categoryData = catDetail.data.data[0];
        }

        setCanvasObjects(pages);
        setCategoryObj(categoryData);
        setCurrentPage(1);
        setSelectedIndex(0);
      } catch (e) {
        console.error("Canvas load failed", e);
      } finally {
        setLoader(false);
      }
    };

    loadData();
  }, [templateID, createID, updateID, loadCategories]);

  /* ======================================================
     2️⃣ INITIAL CANVAS RENDER (ONCE PER LOAD)
  ====================================================== */
  useEffect(() => {
    if (!categoryObj || canvasObjects.length === 0) return;
    if (initializedRef.current) return;

    const raf = requestAnimationFrame(() => {
      const el = document.getElementById("canvas-1");
      if (!el) return;

      initCanvases(categoryObj, canvasObjects);
      initializedRef.current = true;
    });

    return () => cancelAnimationFrame(raf);
  }, [canvasObjects, categoryObj]);

  /* ======================================================
     3️⃣ ACTIVE PAGE SWITCH
  ====================================================== */
  useEffect(() => {
    const c = canvasesRef.current[currentPage - 1];
    if (c) setcanvasObj(c);
  }, [currentPage]);

  /* ======================================================
     4️⃣ CANVAS CREATION
  ====================================================== */
  const initCanvases = (category, pages) => {
    setsafeMargin(category.safe_margin);
    setcutMargin(category.cut_margin);
    setProductmargin(true);

    canvasesRef.current = [];

    const ratio = Math.min(
      600 / category.canvas_width_px,
      600 / category.canvas_height_px
    );

    pages.forEach((page, index) => {
      const canvas = new fabric.Canvas(`canvas-${index + 1}`, {
        width: category.canvas_width_px * ratio,
        height: category.canvas_height_px * ratio,
        selection: true,
        preserveObjectStacking: true,
      });

      canvas.renderOnAddRemove = true;
      canvas.skipTargetFind = false;

      // Prevent textboxes from overflowing outside canvas bounds
      const clampTextboxToCanvas = (obj) => {
        if (!obj) return;
        if (obj.type !== "textbox" && obj.type !== "i-text") return;
        normalizeTextBaseline(obj);

        const canvasW = canvas.getWidth();
        const canvasH = canvas.getHeight();

        const left = Number.isFinite(obj.left) ? obj.left : 0;
        const top = Number.isFinite(obj.top) ? obj.top : 0;

        const fixedWidth = obj._fixedWidth || obj.width || 200;
        const fixedHeight = obj._fixedHeight || obj.height || 60;

        // Keep object position inside canvas
        const safeLeft = Math.max(0, Math.min(left, Math.max(0, canvasW - fixedWidth - 2)));
        const safeTop = Math.max(0, Math.min(top, Math.max(0, canvasH - fixedHeight - 2)));
        if (safeLeft !== left) obj.set("left", safeLeft);
        if (safeTop !== top) obj.set("top", safeTop);

        // If the fixed width would overflow due to position, clamp it
        const maxW = canvasW - (obj.left || 0) - 2;
        const clampedFixedWidth = Math.max(20, Math.min(fixedWidth, maxW));
        if (clampedFixedWidth !== fixedWidth) {
          obj._fixedWidth = clampedFixedWidth;
          obj.set("width", clampedFixedWidth);
        } else {
          obj.set("width", fixedWidth);
        }

        obj.set("height", fixedHeight);
        obj.set("splitByGrapheme", false);
        obj.initDimensions();
        obj.setCoords();
      };

      canvas.on("text:changed", function (opt) {
        const obj = opt.target;
        if (!obj) return;
        if (obj.type !== "textbox" && obj.type !== "i-text") return;

        clampTextboxToCanvas(obj);

        // Get the locked dimensions (set on load or creation)
        const fixedWidth = obj._fixedWidth || obj.width;
        const fixedHeight = obj._fixedHeight || obj.height;
        const originalFontSize = obj._originalFontSize || obj.fontSize;

        // STEP A: Always enforce fixed width
        if (obj.width !== fixedWidth) {
          obj.set("width", fixedWidth);
        }

        // STEP B: Always enforce fixed height
        // This is the KEY fix — height must NEVER grow
        obj.set("height", fixedHeight);

        // STEP C: Recalculate text layout with fixed dimensions
        obj.initDimensions();

        // Helper: check if any text line overflows the fixed width
        const hasWidthOverflow = () => {
          if (!obj._textLines) return false;
          for (let i = 0; i < obj._textLines.length; i++) {
            if (obj.getLineWidth(i) > fixedWidth) return true;
          }
          return false;
        };

        // Helper: check if text overflows the fixed height
        const hasHeightOverflow = () => {
          const h = obj.calcTextHeight ? obj.calcTextHeight() : obj.height;
          return h > fixedHeight;
        };

        // STEP D: Check if text overflows (width OR height)
        if (hasWidthOverflow() || hasHeightOverflow()) {
          // Text overflows → shrink font size until it fits both dimensions
          let safety = 0;
          while (safety < 300) {
            const newSize = Math.max(6, obj.fontSize - 0.5);
            obj.set("fontSize", newSize);
            obj.initDimensions();

            if ((!hasWidthOverflow() && !hasHeightOverflow()) || newSize <= 6) break;
            safety++;
          }
        } else {
          // Text has room → try growing font back to original
          let safety = 0;
          while (obj.fontSize < originalFontSize && safety < 300) {
            const nextSize = Math.min(originalFontSize, obj.fontSize + 0.5);
            obj.set("fontSize", nextSize);
            obj.initDimensions();

            // Re-enforce fixed height after font change
            obj.set("height", fixedHeight);

            if (hasWidthOverflow() || hasHeightOverflow()) {
              obj.set("fontSize", Math.max(6, obj.fontSize - 0.5));
              obj.initDimensions();
              obj.set("height", fixedHeight);
              break;
            }
            safety++;
          }
        }

        // STEP E: Final enforcement — height must stay fixed
        obj.set("height", fixedHeight);
        obj.setCoords();
        clampTextboxToCanvas(obj);
        canvas.requestRenderAll();
      });

      canvas.on("text:editing:entered", function (opt) {
        const obj = opt.target;
        if (!obj) return;

        // Store fixed dimensions if not already stored
        if (!obj._fixedWidth) {
          obj._fixedWidth = obj.width || 200;
        }
        if (!obj._fixedHeight) {
          // Lock current height as the boundary
          obj._fixedHeight = obj.height || obj.calcTextHeight() || 60;
        }
        if (!obj._originalFontSize) {
          obj._originalFontSize = obj.fontSize;
        }

        // Enforce fixed height immediately on edit start
        obj.set("height", obj._fixedHeight);
        clampTextboxToCanvas(obj);
        obj.initDimensions();
        canvas.requestRenderAll();
      });

      canvas.on("text:editing:exited", function (opt) {
        const obj = opt.target;
        if (!obj) return;

        // Re-enforce fixed dimensions after editing
        if (obj._fixedWidth) obj.set("width", obj._fixedWidth);
        if (obj._fixedHeight) obj.set("height", obj._fixedHeight);

        clampTextboxToCanvas(obj);
        obj.initDimensions();
        obj.setCoords();
        canvas.requestRenderAll();
      });

      canvas.on("object:added", function (opt) {
        const obj = opt.target;
        if (!obj) return;
        if (obj.type !== "textbox" && obj.type !== "i-text") return;
        normalizeTextBaseline(obj);

        // Only set fixed dimensions if not already set
        if (!obj._fixedWidth) {
          obj._fixedWidth = obj.width || 200;
        }
        if (!obj._fixedHeight) {
          obj._fixedHeight = obj.height || 60;
        }
        if (!obj._originalFontSize) {
          obj._originalFontSize = obj.fontSize || 20;
        }

        obj.set({
          width: obj._fixedWidth,
          height: obj._fixedHeight,
          splitByGrapheme: false,
        });

        clampTextboxToCanvas(obj);
        obj.initDimensions();
        canvas.requestRenderAll();
      });

      canvas.on("object:removed", function (opt) {
        const obj = opt.target;
        if (!obj) return;
        if (obj._originalFontSize) delete obj._originalFontSize;
        if (obj._originalHeight) delete obj._originalHeight;
      });

      // Central helper to update toolbar state based on selected object
      const updateToolbarForObject = (obj) => {
        if (!obj) return;

        setShowToolbar(true);

        if (obj.type === "textbox") {
          setTextToolbar(true);
          setelementStrokColor(false);
          setshowUploadToolbar(false);
        } else if (obj.type === "image") {
          setTextToolbar(false);
          setelementStrokColor(false);
          setshowUploadToolbar(true);
        } else {
          setTextToolbar(false);
          setelementStrokColor(true);
          setshowUploadToolbar(false);
        }
      };

      // Keep existing mouse:down behavior for compatibility
      canvas.on("mouse:down", () => {
        const obj = canvas.getActiveObject();
        updateToolbarForObject(obj);
      });

      // Also react to Fabric selection events so first click is handled reliably
      canvas.on("selection:created", (e) => {
        const obj =
          (e && Array.isArray(e.selected) && e.selected[0]) ||
          e?.target ||
          canvas.getActiveObject();
        updateToolbarForObject(obj);
      });

      canvas.on("selection:updated", (e) => {
        const obj =
          (e && Array.isArray(e.selected) && e.selected[0]) ||
          e?.target ||
          canvas.getActiveObject();
        updateToolbarForObject(obj);
      });

      const json = page.page_details
        ? safeDecodeURIComponent(page.page_details)
        : null;

      if (json) {
        // Preserve our scaled dimensions; avoid loadFromJSON overwriting with template dimensions
        const parsed = typeof json === "string" ? JSON.parse(json) : { ...json };
        delete parsed.width;
        delete parsed.height;
        delete parsed.viewportTransform;
        const jsonToLoad = typeof json === "string" ? JSON.stringify(parsed) : parsed;

        canvas.loadFromJSON(jsonToLoad, () => {
          if (canvas.disposed) return;

          canvas.getObjects().forEach((obj) => {
            if (obj.type === "line") return canvas.remove(obj);

            if (
              obj.type === "group" &&
              obj.getObjects().every((o) => o.type === "line")
            ) {
              return canvas.remove(obj);
            }

            obj.selectable = true;
            obj.evented = true;
            obj.hasControls = true;
            obj.hasBorders = true;

            if (obj.type === "textbox") {
              obj.splitByGrapheme = false;
            }
          });
          canvas.getObjects().forEach(function (obj) {
            if (obj.type !== "textbox" && obj.type !== "i-text") {
              return;
            }
            normalizeTextBaseline(obj);

            // CRITICAL: Lock both width AND height
            // Use the object's OWN dimensions from template JSON
            // Do NOT override with canvas-wide dimensions

            // Lock width to object's own template width
            const lockedWidth = obj.width && obj.width > 20 ? obj.width : 200;

            // Lock height to object's own template height
            // calcTextHeight() gives current content height
            const contentHeight = obj.calcTextHeight ? obj.calcTextHeight() : obj.height || 60;
            const lockedHeight = obj.height && obj.height > 10 ? obj.height : contentHeight;

            obj.set({
              width: lockedWidth,
              height: lockedHeight,
              splitByGrapheme: false,
              // Store originals as custom properties
              _fixedWidth: lockedWidth,
              _fixedHeight: lockedHeight,
              _originalFontSize: obj.fontSize,
            });

            clampTextboxToCanvas(obj);
            obj.initDimensions();
          });
          canvas.requestRenderAll();

          canvas.discardActiveObject();
          canvas.renderAll();
          onPageCanvasReady?.(index + 1, canvas);
        });
      } else {
        onPageCanvasReady?.(index + 1, canvas);
      }

      canvasesRef.current.push(canvas);
    });

    if (canvasesOriganl.length === 0) {
      setcanvasesOriganl(canvasesRef.current);
    }

    setcanvases(canvasesRef.current);
    setcanvasObj(canvasesRef.current[0]);

    localStorage.setItem(
      "canvas_size",
      `${category.canvas_width_in}-${category.canvas_height_in}`
    );
    localStorage.setItem("pr_file_size", category.pr_file_size);

    if (window.innerWidth <= 770) closeTab();
  };

  return (
    <div className="canvas-area">
      {canvasObjects.map((_, index) => (
        <div
          key={index}
          style={{ display: index + 1 === currentPage ? "block" : "none" }}
        >
          <canvas id={`canvas-${index + 1}`} />
        </div>
      ))}

      <ProductMargin
        Canvaseditor={currentPageObject}
        Productmargin={Productmargin}
        safeMargin={safeMargin}
        cutMargin={cutMargin}
      />
    </div>
  );
}
